var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.7441C15.3613 19.7441 19.7949 15.3105 19.7949 9.94922C19.7949 4.57812 15.3613 0.154297 9.99023 0.154297C4.62891 0.154297 0.205078 4.57812 0.205078 9.94922C0.205078 15.3105 4.63867 19.7441 10 19.7441ZM10 13.2305C6.93359 13.2305 4.59961 14.4609 3.69141 15.6914C2.31445 14.1777 1.47461 12.166 1.47461 9.94922C1.47461 5.22266 5.27344 1.41406 9.99023 1.41406C14.7168 1.41406 18.5254 5.22266 18.5352 9.94922C18.5352 12.166 17.6953 14.1875 16.3086 15.7012C15.4004 14.4609 13.0762 13.2305 10 13.2305ZM10 11.5605C11.875 11.5703 13.3301 9.96875 13.3301 7.87891C13.3301 5.91602 11.8555 4.27539 10 4.27539C8.14453 4.27539 6.66016 5.91602 6.66992 7.87891C6.67969 9.96875 8.125 11.5508 10 11.5605Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.0d50cf4f5a00365c0c2c14f791bbc009.svg";
export { ForwardRef as ReactComponent };